import { responsiveMediaAbove } from '../settings/responsive';
import { Section } from '../tools/section';
import { Accordion } from '../objects/Accordion';

const SELECTOR_ACCORDION = '[data-accordion]';
const SELECTOR_SLIDE = '[data-accordion-slide]';

class Footer extends Section {
  private slides: NodeListOf<HTMLDetailsElement> | null = null;
  private resizeTimer: number | null = null;
  private accordionElement: HTMLElement | null = null;
  private accordion: Accordion | null = null;

  queryChildren(container: HTMLElement): void {
    this.slides = this.container.querySelectorAll(SELECTOR_SLIDE);
    this.accordionElement = container.querySelector(SELECTOR_ACCORDION);
  }

  attachEvents(container: HTMLElement): void {
    if (!this.accordionElement) return;

    this.accordion = new Accordion(this.accordionElement);

    this.setSlidesOpen();
    window.addEventListener('resize', this.onResize);
  }

  detatchEvents() {
    if (this.accordion) this.accordion.detachEvents();
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    // Debounces the resize handle method
    window.addEventListener('resize', () => {
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => this.setSlidesOpen(), 100);
    });
  };

  private setSlidesOpen(): void {
    if (!this.slides) return;
    
    const isScreenMediumOrAbove = !!responsiveMediaAbove('medium'); // Cast to boolean

    this.slides.forEach((slide) => (slide.open = isScreenMediumOrAbove));
  }
}

Section.register('[data-footer]', Footer);